import { LOGGED_IN_CATEGORY_FULL_WIDTH_XP_240704 } from "@faire/web-api/indigofair/settings/LOGGED_IN_CATEGORY_FULL_WIDTH_XP_240704";

import {
  assignSetting,
  getSettingValueWithoutAssignment,
} from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingLoggedInCatnavFullWidthXP = (): boolean =>
  getSettingValueWithoutAssignment(
    LOGGED_IN_CATEGORY_FULL_WIDTH_XP_240704,
    false
  );

export const assignSettingLoggedInCatnavFullWidthXP = (): Promise<void> =>
  assignSetting(LOGGED_IN_CATEGORY_FULL_WIDTH_XP_240704);
